/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BoxSign32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlDarkBlue}
                d="M0 7.692v16.616c0 2.675.278 3.645.801 4.623a5.452 5.452 0 002.268 2.268c.978.523 1.948.801 4.623.801h16.616c2.675 0 3.645-.278 4.623-.801a5.452 5.452 0 002.268-2.268c.523-.978.801-1.948.801-4.623V7.692c0-2.675-.278-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            />
            <path
                fill={vars.white}
                d="M23.5 23a.5.5 0 010 1h-15a.5.5 0 110-1h15zM14 8c1.936 0 3.192 2.265 2.997 4.584-.14 1.652-1.278 3.625-2.87 5.267l-.11.111.078.123c.359.54.793.863 1.282.91L15.5 19c.394 0 .73-.251 1.179-.887l.197-.295.35-.544.155-.226.142-.193C17.94 16.32 18.381 16 19 16c.674 0 1.139.39 1.468.983.077.138.139.266.203.422l.099.258.32.93.07.192.081.185.11-.03c.243-.08.508-.245.796-.507l.146-.14a1 1 0 111.414 1.414C22.867 20.547 21.961 21 21 21c-.674 0-1.138-.39-1.468-.983a3.822 3.822 0 01-.202-.422l-.1-.258-.332-.965-.44.683C17.613 20.32 16.781 21 15.5 21c-1.252 0-2.229-.576-2.948-1.558l-.09-.127-.058.043c-.916.674-1.9 1.21-2.883 1.529l-.246.075a1 1 0 11-.55-1.924c.921-.263 1.867-.797 2.738-1.475l.127-.103-.031-.1c-.36-1.175-.542-2.568-.558-4.079v-.284C11.008 10.197 12.052 8 14 8zm0 2c-.437 0-.994 1.173-1 3.003-.003.963.074 1.854.217 2.638l.038.196.165-.197c.84-1.038 1.427-2.136 1.563-3.045l.02-.179C15.114 11.111 14.499 10 14 10zm5 3a1 1 0 110 2 1 1 0 010-2z"
            />
        </g>
    </AccessibleSVG>
);

export default BoxSign32;
